/**
 * AI商品ならカートボタンを隠す
 * - slug に "_ai" を含む場合のみ適用
 */
(() => {
  // 商品詳細ページ以外は何もしない
  if (!window.location.pathname.includes('/products/')) return;

  const slug = window.location.pathname.split('/').pop() || '';
  const isAi = slug.includes('_ai');

  if (!isAi) return;

  // HTMLにクラスを付与
  document.documentElement.classList.add('is-ai-product');

  // すでに注入済みなら二重に入れない
  if (document.getElementById('ai-hide-cart-style')) return;

  const style = document.createElement('style');

  style.id = 'ai-hide-cart-style';

  style.textContent = `
    html.is-ai-product .product-form__submit {
      visibility: hidden !important;
      pointer-events: none !important;
      height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
    }
  `;

  // 可能ならheadに追加
  (document.head || document.documentElement).appendChild(style);
})();

/**
 * 許可する商品カテゴリ
 */
const allowedKeys = [
  'keyholder',
  'keyholder_ai',
  'omamori_keyholder',
  'aurora_keyholder',
  'fuchinashi_keyholder',
  'stand',
  'stand_ai',
  'aurora_stand',
  'ministand',
  'stand_keyholder',
  'aurora_stakey',
  'charm',
  'aurora_charm',
  'umbrella_marker',
  'aurora_umbrella_marker',
  'block',
  'mascot',
  'card',
  'diorama_ai',
  'diorama',
  'diorama_square',
];

/**
 * 台座形状の種類
 */
const baseShapeName = [
  {
    value: 'ellipse',
    label: '楕円',
  },
  {
    value: 'rectangle',
    label: '長方形',
  },
  {
    value: 'circle',
    label: '丸',
  },
  {
    value: 'square',
    label: '四角',
  },
  {
    value: 'hexagon',
    label: '六角形',
  },
  {
    value: 'cloud',
    label: '雲',
  },
  {
    value: 'star',
    label: '星',
  },
  {
    value: 'heart',
    label: 'ハート',
  },
  {
    value: 'flower',
    label: '花',
  },
  {
    value: 'cherryblo',
    label: '桜',
  },
  {
    value: 'cat',
    label: 'ネコ',
  },
  {
    value: 'bear',
    label: 'クマ',
  },
];

const SMART_BUTTON_SELECTOR =
  '.smart-design-button[data-smart-design-launch="true"]';

/**
 * 最大一致キーを返す
 *
 * @param {string} slug
 * @param {string[]} keys
 * @returns {string|null}
 */
const getBestMatchedKey = (slug, keys) => {
  const matched = keys.filter((key) => slug.includes(key));

  if (matched.length === 0) {
    return null;
  }

  // 最も長いキーを採用
  // omamori_keyholderがkeyholderより優先される
  matched.sort((a, b) => b.length - a.length);

  return matched[0];
};

/**
 * 入稿方法selectを取得
 *
 * @returns {HTMLSelectElement|null}
 */
const getSubmissionTypeSelect = () => {
  const productInfo = document.querySelector('.product__info-container');
  const selects = Array.from(productInfo?.querySelectorAll(
    'select[name="select_submission_type"], select[name="select_submission_type_sd"]',
  ) || []);

  // GPOが旧フィールドを残している場合は、現在表示されている選択欄を優先する。
  return selects.find((select) => !select.disabled && select.getClientRects().length > 0)
    || selects.find((select) => !select.disabled)
    || null;
};

/**
 * display:noneを使わずに非表示にする
 *
 * @param {HTMLElement|null} element
 */
const hideVisually = (element) => {
  if (!element) return;

  element.style.setProperty('visibility', 'hidden', 'important');
  element.style.setProperty('pointer-events', 'none', 'important');
  element.style.setProperty('height', '0px', 'important');
  element.style.setProperty('margin', '0px', 'important');
  element.style.setProperty('padding', '0px', 'important');
  element.style.setProperty('overflow', 'hidden', 'important');
};

/**
 * スマートデザインボタンクリック時の処理
 */
const handleSmartDesignClick = () => {
  const slug = window.location.pathname.split('/').pop() || '';
  const matchedKey = getBestMatchedKey(slug, allowedKeys);

  if (!matchedKey) {
    console.error(
      'Smart Design: 商品カテゴリを判定できませんでした。',
      slug,
    );

    return;
  }

  const productInfo = document.querySelector(
    '.product__info-container',
  );

  if (!productInfo) {
    console.error(
      'Smart Design: .product__info-containerが見つかりません。',
    );

    return;
  }

  const formData = {};
  let hasError = false;

  /**
   * 必須項目のバリデーション
   */
  const requiredLabels = productInfo.querySelectorAll(
    '.gpo-label.required',
  );

  requiredLabels.forEach((label) => {
    const field = label.parentElement?.querySelector(
      'input, select, textarea',
    );

    const isHidden =
      !field ||
      field.offsetParent === null ||
      field.disabled;

    if (!field || isHidden) {
      return;
    }

    // ファイル項目はスキップ
    if (field.type === 'file') {
      return;
    }

    const fieldType = field.type;
    const value = String(field.value ?? '').trim();

    let isEmpty = false;

    if (
      fieldType === 'checkbox' ||
      fieldType === 'radio'
    ) {
      const fieldName = field.getAttribute('name');

      if (fieldName) {
        const checkedField = productInfo.querySelector(
          `[name="${CSS.escape(fieldName)}"]:checked`,
        );

        isEmpty = !checkedField;
      } else {
        isEmpty = !field.checked;
      }
    } else {
      isEmpty = value === '';
    }

    if (isEmpty) {
      hasError = true;
    }
  });

  if (hasError) {
    alert('必須項目をすべて入力してください。');

    return;
  }

  /**
   * 商品カテゴリ
   */
  formData.productType = matchedKey;

  /**
   * 商品名
   */
  const productTitle = document
    .querySelector('.product__title > h1')
    ?.textContent?.trim();

  if (productTitle) {
    formData.productTitle = productTitle;
  }

  /**
   * 価格
   */
  const basePriceEl = document.querySelector(
    '.price-item.price-item--regular',
  );

  const basePrice = Number(
    basePriceEl?.textContent?.replace(/[^\d]/g, '') || 0,
  );

  formData.price = basePrice;

  /**
   * サイズ
   *
   * カード：60×90mm固定
   * お守り：40×65mm固定
   * その他：商品オプションの選択値
   */
  const sizeSelect = document.querySelector(
    '[name*="select_product_size"]',
  );

  const size =
    matchedKey === 'card'
      ? '60×90mm'
      : matchedKey === 'omamori_keyholder'
        ? '40×65mm'
        : sizeSelect?.value;

  if (!size) {
    alert(
      'サイズが不正のためデザインシミュレーター対象外です。',
    );

    return;
  }

  formData.size = size;

  /**
   * 丸カン追加
   */
  const jumpRingSelect = document.querySelector(
    '[name="select_has_jumpring_hole"]',
  );

  formData.hasJumpRing =
    jumpRingSelect?.value === '有り';

  /**
   * 台座印刷
   */
  const basePrintSelect = document.querySelector(
    '[name="select_has_base_print"]',
  );

  formData.hasBasePrint =
    basePrintSelect?.value === '印刷あり';

  /**
   * 台座形状
   */
  const baseShapeSelect = document.querySelector(
    '[name="select_base_shape"]',
  );

  const baseShape =
    baseShapeSelect?.value ?? '';

  const shapeValue = baseShapeName.find(
    (shape) => shape.label === baseShape,
  );

  formData.baseShape =
    shapeValue?.value ?? null;

  /**
   * 印刷面
   */
  const printFaceSelect = document.querySelector(
    '[name="side-quantity"]:checked',
  );

  formData.isPrintBothFaces = Boolean(
    printFaceSelect?.value?.includes('両面'),
  );

  /**
   * お守りの紐の色
   *
   * お守り以外の商品ではnull
   */
  if (matchedKey === 'omamori_keyholder') {
    const omamoriColorSelect = document.querySelector(
      '[name*="select_attachment"]',
    );

    const omamoriColor =
      omamoriColorSelect?.value?.trim();

    formData.omamoriColor =
      omamoriColor || null;
  } else {
    formData.omamoriColor = null;
  }

  console.log(
    'Created formData to use in Smart Design Simulator:',
    formData,
  );

  /**
   * React側に状態とデータをセット
   */
  window.smartDesignModalState = {
    isOpen: true,
    formData,
  };

  /**
   * React側へ変更通知イベントを送る
   */
  window.dispatchEvent(
    new CustomEvent('smartDesignStateChange', {
      detail: window.smartDesignModalState,
    }),
  );
};

/**
 * ボタンがDOM再生成されてもクリックできるよう、
 * documentにクリックイベントを委譲する
 */
if (!window.smartDesignClickHandlerRegistered) {
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const button = event.target.closest(
        SMART_BUTTON_SELECTOR,
      );

      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      handleSmartDesignClick();
    },
    true,
  );

  window.smartDesignClickHandlerRegistered = true;
}

/**
 * スマート入稿ボタンの初期化
 *
 * @returns {boolean}
 */
const initSmartDesign = () => {
  // 商品詳細ページ以外では実行しない
  if (
    !window.location.pathname.includes('/products/')
  ) {
    return false;
  }

  const slug =
    window.location.pathname.split('/').pop() || '';

  const matchedKey = getBestMatchedKey(
    slug,
    allowedKeys,
  );

  if (!matchedKey) {
    return false;
  }

  const isAi = slug.includes('_ai');

  const productInfo = document.querySelector(
    '.product__info-container',
  );

  if (!productInfo) {
    return false;
  }

  // 修復前のDOMを記録し、再生成によって異常の証拠が消えるのを防ぐ。
  window.smartDesignDiagnostics?.observe(productInfo, 'before', 'sd-button-20260909-3');

  /**
   * ボタンを作成または再利用
   */
  let button = productInfo.querySelector(
    SMART_BUTTON_SELECTOR,
  );

  if (!button) {
    button = document.createElement('button');

    button.className = 'smart-design-button';
    button.type = 'button';
    button.dataset.smartDesignLaunch = 'true';
  }

  const buttonText = isAi
    ? '画像アップロードして作成開始'
    : 'デザインシミュレーターで作成開始';
  // 同じtextContentの再代入もMutationObserverを発火させるため避ける。
  if (button.textContent !== buttonText) button.textContent = buttonText;

  if (isAi) {
    button.style.marginBottom = '10px';
  } else {
    button.style.removeProperty('margin-bottom');
  }

  /**
   * 商品フォーム全体の前ではなく、カートボタンの直前に配置する。
   * GPOの旧ボタンが非表示の親に残る場合は、表示可能な親を持つボタンを使う。
   * カート自身はシミュレーター選択中に隠すため、親だけを確認する。
   */
  const hasVisibleParents = (element) => {
    for (let parent = element.parentElement; parent && parent !== productInfo; parent = parent.parentElement) {
      const style = window.getComputedStyle(parent);
      if (parent.hidden || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    }
    return true;
  };
  const anchor = Array.from(productInfo.querySelectorAll(
    '.product-form__submit, .gpo-original-atc-button, .gpo-clone-atc-button, form[data-type="add-to-cart-form"] [name="add"]',
  )).find(hasVisibleParents);
  if (anchor) {
    if (button.parentElement !== anchor.parentElement || button.nextElementSibling !== anchor) {
      anchor.insertAdjacentElement('beforebegin', button);
    }
  } else if (button.parentElement !== productInfo) {
    productInfo.appendChild(button);
  }

  /**
   * 台座形状によりデザインシミュレーターを制御
   */
  const checkBaseShapeSelected = () => {
    const baseShapeSelect = productInfo.querySelector(
      '[name="select_base_shape"]',
    );

    if (!baseShapeSelect) {
      return;
    }

    const baseShape =
      baseShapeSelect.options[
        baseShapeSelect.selectedIndex
      ]?.textContent?.trim();

    const submissionTypeSelect =
      getSubmissionTypeSelect();

    if (!submissionTypeSelect) {
      return;
    }

    const smartOption =
      submissionTypeSelect.querySelector(
        'option[value="デザインシミュレーター"]',
      );

    const isOriginalShape =
      baseShape ===
      '使用しない(オリジナルで形を作る)';

    if (isOriginalShape) {
      if (smartOption) {
        smartOption.style.display = 'none';
      }

      if (
        submissionTypeSelect.value ===
        'デザインシミュレーター'
      ) {
        const firstValidOption = Array.from(
          submissionTypeSelect.options,
        ).find((option) => {
          return (
            !option.disabled &&
            option.style.display !== 'none'
          );
        });

        if (firstValidOption) {
          submissionTypeSelect.value =
            firstValidOption.value;

          submissionTypeSelect.dispatchEvent(
            new Event('change', {
              bubbles: true,
            }),
          );
        }
      }
    } else if (smartOption) {
      smartOption.style.display = '';
    }
  };

  /**
   * 入稿方法によりボタン表示を切り替える
   */
  const checkSmartDesignSelected = () => {
    const submissionTypeSelect =
      getSubmissionTypeSelect();
    const selectedOption = submissionTypeSelect?.selectedOptions[0];
    let mode = productInfo.dataset.smartDesignMode || 'pending';
    if (isAi) {
      mode = 'simulator';
    } else if (selectedOption && submissionTypeSelect.value.trim()) {
      mode = `${submissionTypeSelect.value} ${selectedOption.textContent}`
        .includes('デザインシミュレーター') ? 'simulator' : 'normal';
    }
    // select消失中は直前の判定を維持し、通常カートへ戻さない。
    if (productInfo.dataset.smartDesignMode !== mode) {
      productInfo.dataset.smartDesignMode = mode;
    }
    button.hidden = mode !== 'simulator';
    button.style.removeProperty('display');
  };

  checkBaseShapeSelected();
  checkSmartDesignSelected();
  window.smartDesignDiagnostics?.observe(productInfo, 'after', 'sd-button-20260909-3');

  return true;
};

/**
 * MutationObserverによる再同期
 */
let smartDesignSyncScheduled = false;

const scheduleSmartDesignSync = () => {
  if (smartDesignSyncScheduled) {
    return;
  }

  smartDesignSyncScheduled = true;

  requestAnimationFrame(() => {
    smartDesignSyncScheduled = false;

    initSmartDesign();
    hideAllAiSelects();
  });
};

const observer = new MutationObserver(() => {
  scheduleSmartDesignSync();
});

const startSmartDesignObserver = () => {
  if (!document.body) {
    return;
  }

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['selected', 'value', 'name'],
  });

  scheduleSmartDesignSync();
};

if (document.body) {
  startSmartDesignObserver();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    startSmartDesignObserver,
    {
      once: true,
    },
  );
}

// change/inputはその場で反映し、GPOがイベント後に変更する場合も再同期する。
const handleSmartDesignSelectionChange = () => {
  initSmartDesign();
  scheduleSmartDesignSync();
};
document.addEventListener('change', handleSmartDesignSelectionChange, true);
document.addEventListener('input', handleSmartDesignSelectionChange, true);
window.addEventListener('pageshow', handleSmartDesignSelectionChange);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) handleSmartDesignSelectionChange();
});
// .valueへの直接代入はMutationObserverでは検知できない。
if (window.location.pathname.includes('/products/')) {
  window.setInterval(() => {
    if (!document.hidden) initSmartDesign();
  }, 250);
}

/**
 * AI商品のselect項目をすべて非表示にする
 */
const hideAllAiSelects = () => {
  const slug =
    window.location.pathname.split('/').pop() || '';

  const matchedKey = getBestMatchedKey(
    slug,
    allowedKeys,
  );

  if (!matchedKey) {
    return;
  }

  const isAi = slug.includes('_ai');

  if (!isAi) {
    return;
  }

  const productInfo = document.querySelector(
    '.product__info-container',
  );

  if (!productInfo) {
    return;
  }

  const selects = productInfo.querySelectorAll('select');

  selects.forEach((select) => {
    const parentElement =
      select.closest('.gpo-element') ||
      select.closest('.product-form__input') ||
      select;

    hideVisually(parentElement);
  });
};

/**
 * DOMが安定するまで待機する
 *
 * @param {Function} callback
 * @param {number} checkInterval
 * @param {number} stableCount
 */
const waitForStableDOM = (
  callback,
  checkInterval = 100,
  stableCount = 3,
) => {
  let lastElementCount =
    document.getElementsByTagName('*').length;

  let stableFrames = 0;

  const intervalId = window.setInterval(() => {
    const currentElementCount =
      document.getElementsByTagName('*').length;

    if (
      currentElementCount === lastElementCount
    ) {
      stableFrames += 1;
    } else {
      stableFrames = 0;
      lastElementCount =
        currentElementCount;
    }

    if (stableFrames < stableCount) {
      return;
    }

    window.clearInterval(intervalId);

    callback();
  }, checkInterval);
};

/**
 * ページロード後にAI商品のselect項目を非表示にする
 */
window.addEventListener('load', () => {
  waitForStableDOM(() => {
    hideAllAiSelects();

    // select項目を非表示にした後にも再同期
    scheduleSmartDesignSync();
  });
});
